module.exports = __webpack_public_path__ + "img/image_17.648c5d1e.png";